<template>
  <IconLucideMapPin />
</template>
